// @flow
import * as React from "react"
import { Link } from "react-static"
import { RouteData } from "react-static"
import { css } from "emotion"
import { Container } from "../StyledComponents"
import Slider from "react-slick"
import { ImageFit } from "../ImageFit/index"
import moment from "moment"
import { ArrowRight } from "../Icons/ArrowRight"
import { ArrowLeft } from "../Icons/ArrowLeft"
import { color } from "../../styles/variables"
import memoizeOne from "memoize-one"
import { filterByProp } from "../../screens/EventsCalendar/utils"

const identity = (x) => x

const shallowMemoized = memoizeOne(identity)

const dateTimeFormat = "MMMM, D YYYY h:mmA"
const dateTimeFormatNoTime = "MMMM, D YYYY"

function Next({
  className = "",
  ...props
}: {
  className?: string,
  style?: {},
  onClick?: () => any
}) {
  return (
    <button className={className} style={props.style} onClick={props.onClick}>
      <ArrowRight />
    </button>
  )
}

function Previous({
  className = "",
  ...props
}: {
  className?: string,
  style?: {},
  onClick?: () => any
}) {
  return (
    <button className={className} style={props.style} onClick={props.onClick}>
      <ArrowLeft />
    </button>
  )
}

type event = {
  name: string,
  imgUrl: string,
  id: string | number,
  start: string,
  end: string,
  summary: string,
  categoryName: string,
  topic: string
}

function getLatestEvents(events: event[], count = 10) {
  return events
    .filter((event) => moment(event.start).isAfter(moment().subtract(1, "day")))
    .filter((event, i) => i <= count)
}

let style = {
  root: css`
    .tags {
      a {
        font-size: 14px;
        color: ${color.rgb.gray[1]};
      }
    }

    .summary {
      font-weight: 700;
    }
  `
}

function SliderContainer(props: { events: event[] }) {
  const memoizedEvents = shallowMemoized(getLatestEvents(props.events))

  return (
    <Container className={style.root}>
      <Slider
        {...{
          dots: false,
          infinate: true,
          speed: 500,
          slidesToShow:
            memoizedEvents.length === 1
              ? 1
              : memoizedEvents.length === 2
              ? 2
              : 3,
          slidesToScroll: 1,
          centerMode: true,
          lazyLoad: "progressive",
          arrows: true,
          draggable: false,
          nextArrow: <Next />,
          prevArrow: <Previous />,
          useCss: true,
          waitForAnimate: true,
          variableWidth: false,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                centerPadding: "0",
                slidesToShow: 1
              }
            },
            {
              breakpoint: 992,
              settings: {
                centerPadding: "20px",
                slidesToShow: 2
              }
            }
          ]
        }}
      >
        {memoizedEvents.map((event) => (
          <div
            key={event.id}
            className={css`
              max-width: 240px;

              img {
                width: 100%;
                height: auto;
                max-width: 240px;
                margin: auto;
              }
            `}
          >
            <div>
              <a
                href={`https://secure.spiritualliving.org/np/clients/spiritualliving/event.jsp?event=${
                  event.id
                }`}
              >
                <ImageFit src={event.imgUrl} />
              </a>
              <h4 className="h6">
                {moment(event.start).format(
                  event.startTime ? dateTimeFormat : dateTimeFormatNoTime
                )}
              </h4>
              <h3 className="h5">
                <a
                  href={`https://secure.spiritualliving.org/np/clients/spiritualliving/event.jsp?event=${
                    event.id
                  }`}
                >
                  {event.name}
                </a>
              </h3>
              {event.summary && <div className="summary">{event.summary}</div>}
              <div className="tags">
                <Link to={`/events?topic=${event.topic}`}>{event.topic}</Link>
              </div>
              <a
                href={`https://secure.spiritualliving.org/np/clients/spiritualliving/event.jsp?event=${
                  event.id
                }`}
                className="learn-more"
              >
                Learn More <ArrowRight />
              </a>
            </div>
          </div>
        ))}
      </Slider>
      <div
        className={css`
          margin: 30px auto 0;
          text-align: center;
        `}
      >
        <Link to="/events" className="btn btn-orange">
          View All Events
        </Link>
      </div>
    </Container>
  )
}

export function ActivitesAndEventsSlider(props: { events?: Array<{}> }) {
  return (
    <RouteData>
      {(routeProps) =>
        routeProps.neon &&
        routeProps.neon.events &&
        routeProps.neon.events.events &&
        routeProps.neon.events.events.length > 0 ? (
          <div
            className={css`
              margin: 60px 0 0;

              h4 {
                margin-top: 20px;
              }

              h3 {
                a {
                  color: ${color.rgb.orange[0]};
                }
              }
              h4 {
                a {
                  color: ${color.rgb.black[0]};
                }
              }

              .learn-more {
                text-transform: uppercase;
                color: ${color.rgb.purple[1]};
                margin-top: 20px;
                display: block;

                svg path {
                  fill: ${color.rgb.purple[1]};
                }
              }

              .slick-arrow {
                position: absolute;
                top: 0;
                bottom: 0;
                margin: auto;
                z-index: 500;
                cursor: pointer;
                background: ${color.rgb.white[0]};
                border: none;

                svg {
                  width: 24px;
                  height: auto;

                  path {
                    fill: ${color.rgb.gray[3]};
                  }
                }

                &:focus {
                  outline: none;
                }
              }

              .slick-prev {
                left: -25px;
                padding-right: 25px;
              }

              .slick-next {
                right: -25px;
                padding-left: 25px;
              }

              .slick-slide > div {
                padding: 0 34px;
              }
            `}
          >
            <SliderContainer
              events={
                props.events ? props.events : routeProps.neon.events.events
              }
            />
          </div>
        ) : (
          <span />
        )
      }
    </RouteData>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/FlexibleContent/ActivitesAndEventsSlider.js